import React, { Component } from 'react';
import HyperList from "../../widgets/HyperList";
import { observer } from 'mobx-react';
import { useHistory } from "react-router-dom";
import moment from 'moment';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { faLock } from '@fortawesome/free-regular-svg-icons'
import { faLock } from '@fortawesome/free-solid-svg-icons'


const AccountSelectHyperlist = function (props) {
    let accounts = props.store.accounts.collection;

    let accountIds = props.store.user.accountIds;

    let accountStatus =  props.accountStatus;

    accounts = accounts.filter(account => {
        if (account.accountStatusChanges.length > 0 && accountIds.includes(account.id) ) {
            return account.accountStatusChanges[account.accountStatusChanges.length - 1].status === accountStatus
        }
        if (account.accountStatusChanges.length === 0 && accountStatus == "Active" && accountIds.includes(account.id)) {
            return true
        }
        
        return false;
    })

    const history = useHistory();

    function redirectToAccount(event) {
        let accountId = event.target.value;

        history.push("/student/" + accountId);
    }

    accounts = accounts.map(account => account.include(["employer", "student"]));

    const listItemButton = (accountId, employerName) => {
        if (accountStatus == "Locked") {
            return (<button role="button" aria-notice="Note: Account is currently locked" aria-lable={`Navigate to timesheet selection/submission for ${employerName}`} type="button" value={accountId} onClick={redirectToAccount} className="btn btn-primary btn-slim">View Details</button>)
        }
        else if (accountStatus == "Pending") {
            return (<button role="button" aria-notice="Note: Account will not open timesheet submission until a later date" aria-lable={`Navigate to timesheet selection/submission for ${employerName}`} type="button" value={accountId} onClick={redirectToAccount} className="btn btn-light btn-slim">View Details</button>)
        }
        
        return (<button role="button" aria-lable={`Navigate to timesheet selection/submission for ${employerName}`} type="button" value={accountId} onClick={redirectToAccount} className="btn btn-light btn-slim">Manage Timesheets</button>)
    }

    let hyperListBody = null;
    if (accounts.length > 0) {
        hyperListBody = 
            accounts.map((account, i) =>  
                <li aria-label={`Manage timesheets for ${account.employer.name}`} className="hyperlist-item">
                    <div role="region" aria-label="Account Description" className="hyperlist-item-text">
                        <span aria-label="The name of the employer for this work study account" className="hyperlist-item-title">
                            {account.employer.name}
                        </span>
                        <span aria-label="Time period in which the work study account will be active" className="hyperlist-item-subtitle">{`${moment(account.startDate).format("MMM D")} - ${moment(account.endDate).format("MMM D Y")}`}</span>
                    </div>
                    <div className="hyperlist-item-text">
                        {listItemButton(account.id, account.employer.name)}
                    </div>
                </li>
            )
    }
    else {
        return null;
    }

    let hyperListTitle = "Active Accounts"
    if (accountStatus == "Pending") {
        hyperListTitle = "Inactive Accounts"
    }
    else if (accountStatus == "Locked") {
        hyperListTitle = (
            <span>
                <FontAwesomeIcon icon={faLock} size="lg"/>
                <span className="ml-3">Locked Accounts</span>
            </span>
        )
    }
        

    return (
        <HyperList 
            style={{marginTop: "1.5em"}}
            className={accountStatus == "Locked" ? "hyperlist-locked" : ""}
            store={props.store}
            hyperListBody={hyperListBody}
            listTitle={hyperListTitle}
        />)
}

export default observer(AccountSelectHyperlist);
